// localStorage item name for locale overrides
export const LOCALSTORAGE_LOCALE_NAME = 'locale';

// The default values. The real ones come from the backend.
// See `availableLocales` in `store/modules/profile.js`
export const DEFAULT_LOCALE = 'en';
export const LOCALES = {
	en: 'English',
};
